import React from 'react'

import { AlertNotice } from '@ui/components/AlertNotice'

import { usePageNotice } from './PageNoticeContext'

export const PageNoticeContainer: React.FC = () => {
  const { notices } = usePageNotice()

  if (notices.length === 0) {
    return null
  }

  return (
    <div>
      {notices.map((notice) => (
        <AlertNotice key={notice.id} {...notice} />
      ))}
    </div>
  )
}
